import { Client } from "@core/Client";
import { Constants } from "@core/Utils/Constants";
import { numToColor } from "@core/Utils/HelperFunction";

export class StatisticsWheel extends Phaser.GameObjects.Container {
    private graphics: Phaser.GameObjects.Graphics;
    private background: Phaser.GameObjects.Image;
    private circleNumbersCount: number

    constructor(scene: Phaser.Scene) {
        super(scene)

        this.background = new Phaser.GameObjects.Image(scene, 0, 0, Constants.SPRITESHEET_STATISTICS, (Client.logic.IsDoubleZero() ? "00_StatisticsWheel.png" : "StatisticsWheel.png"));
        this.background.setOrigin(0.5);
        this.add(this.background);

        this.graphics = new Phaser.GameObjects.Graphics(scene);
        this.add(this.graphics);

        this.circleNumbersCount = 37 + (Client.logic.IsDoubleZero() ? 1 : 0)
    }

    RedrawCircleBars(width, height): void {
        this.width = width;
        this.height = height;

        let size = Math.min(width, height);

        this.background.setDisplaySize(size, size);

        let doubleZero = Client.logic.IsDoubleZero()

        let numberStepRadian = 2 * Math.PI / this.circleNumbersCount;
        let offset = (Math.PI * 0.5) + (numberStepRadian * 0.6);

        let circleMaxRadius = size / 2;
        let circleMaxNumberRadius = circleMaxRadius * 0.66;
        let circleMinNumberRadius = circleMaxRadius * 0.2;

        let vx = [0, 0, 0]
        let vy = [0, 0, 0]

        let currentNumberRadius = 0
        let currentNumberRadian = 0
        let nextNumberRadian = 0

        let numberStatistics = Client.logic.CalculateWinNumberStatistics();
        let highestNumStatCt = Math.max(...numberStatistics.map(number => number.count))

        this.graphics.clear();
        (Client.logic.IsDoubleZero() ? Constants.DOUBLE_ZERO_NUMBERS : Constants.SINGLE_ZERO_NUMBERS).forEach((number, index) => {
            let percentage = numberStatistics[number].count / highestNumStatCt;
            if (percentage == 0)
                return;

            currentNumberRadius = circleMinNumberRadius + ((circleMaxNumberRadius - circleMinNumberRadius) * percentage);
            currentNumberRadian = index * numberStepRadian;
            nextNumberRadian = (index + 1) * numberStepRadian;

            vx[0] = 0;
            vy[0] = 0;

            vx[1] = (Math.cos(currentNumberRadian - offset) * currentNumberRadius);
            vy[1] = (Math.sin(currentNumberRadian - offset) * currentNumberRadius);
            vx[2] = (Math.cos(nextNumberRadian - offset) * currentNumberRadius);
            vy[2] = (Math.sin(nextNumberRadian - offset) * currentNumberRadius);

            let color = 0xFF00FF;
            let secondaryColor = 0xFFFFFF;
            switch (numToColor(number)) {
                case 3:
                    color = 0x00FF00;
                    secondaryColor = 0x0B6A42;
                    break
                case 1:
                    color = 0xFF0000;
                    secondaryColor = 0xAF0212;
                    break
                case 0:
                    color = 0x000000;
                    secondaryColor = 0x2B2B2B;
                    break
            }

            let triangle = new Phaser.Geom.Triangle(
                vx[1], vy[1],
                vx[2], vy[2],
                vx[0], vy[0]
            );

            this.graphics.lineStyle(5, color, 1.0);
            this.graphics.fillGradientStyle(secondaryColor, secondaryColor, color, color);
            this.graphics.fillTriangleShape(triangle);

            // Draw inner circle to hide bar starting points
            this.graphics.fillStyle(0x1E1E1E);
            this.graphics.fillCircle(vx[0], vy[0], circleMaxRadius * 0.18);

        })
    }
}
